import { render, staticRenderFns } from "./DataBody5.vue?vue&type=template&id=3a359ac3&"
import script from "./DataBody5.vue?vue&type=script&lang=js&"
export * from "./DataBody5.vue?vue&type=script&lang=js&"
import style0 from "./DataBody5.vue?vue&type=style&index=0&id=3a359ac3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports